document.addEventListener('DOMContentLoaded', function() {
    // Select both tab buttons
    var tabLinks = document.querySelectorAll('.login-page__tab-link');
    // Select both tab content sections
    var tabContents = document.querySelectorAll('.login-page__login');

    // Use a traditional for loop for older JS environments
    for (var i = 0; i < tabLinks.length; i++) {
        (function(index) {
            tabLinks[index].addEventListener('click', function() {
                // Remove .is-active from all links and content
                for (var j = 0; j < tabLinks.length; j++) {
                    tabLinks[j].classList.remove('is-active');
                    tabContents[j].classList.remove('is-active');
                }

                // Add .is-active to the clicked link and the matching content
                tabLinks[index].classList.add('is-active');
                tabContents[index].classList.add('is-active');
            });
        })(i); // Immediately-invoked function to capture "i" properly
    }
});